module.exports = __webpack_public_path__ + "static/media/Mobleapp.915a0412.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/MunafaMart/Mobleapp.jpg
// module id = 337
// module chunks = 0